const PersonalizationActions = {
  SET_PERSONALIZATION_COMPLETION: 'PersonalizedActions.SET_PERSONALIZED_COMPLETED'
};

export default PersonalizationActions;